export enum AccommodationType {
	Other = 'Other',
	Renter = 'Renter',
	Owner = 'Owner',
	PartOwner = 'PartOwner',
	CouncilRenter = 'CouncilRenter',
	WithParents = 'WithParents',
	Tenant = 'Tenant',
	PropertyOwnedByFamily = 'PropertyOwnedByFamily',
	RentFree = 'RentFree',
}
